import { defaultSchema } from "rehype-sanitize";
import type { Schema } from "hast-util-sanitize";

/**
 * Sanitization schema for chat markdown with raw HTML (rehype-raw).
 *
 * CSU Opportunity-to-Grow heatmap (`html_formatted_heatmap`) markup:
 *   <section class="csu-matrix">
 *     <header class="csu-matrix__header"><h2 class="csu-matrix__title">…
 *     <td class="priority-0|1|2|3">…
 *
 * `className` must be allowed on each of those tags explicitly — adding it only
 * to `*` does not preserve classes in hast-util-sanitize. Without this, all
 * frontend `.csu-matrix` CSS never matches.
 */
export const markdownSanitizeSchema: Schema = {
  ...defaultSchema,
  tagNames: [
    ...(defaultSchema.tagNames ?? []),
    "style",
    "header",
    "footer",
    "small",
  ],
  attributes: {
    ...defaultSchema.attributes,
    section: ["className"],
    header: ["className"],
    footer: ["className"],
    div: ["className"],
    table: ["className"],
    thead: ["className"],
    tbody: ["className"],
    tr: ["className"],
    td: ["className"],
    th: ["className"],
    span: ["className"],
    small: ["className"],
    // Color swatches in `.csu-matrix__legend` are empty <i class="csu-matrix__swatch …">
    i: ["className", "ariaHidden"],
    p: ["className"],
    h1: ["className"],
    h2: ["className"],
    h3: ["className"],
    h4: ["className"],
    strong: ["className"],
  },
};
